var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.857 1.81C.88 2.785.88 4.356.88 7.5c0 3.142 0 4.714.976 5.69s2.547.976 5.69.976h3.334c3.142 0 4.714 0 5.69-.976s.976-2.548.976-5.69 0-4.714-.976-5.69c-.976-.977-2.548-.977-5.69-.977H7.547c-3.142 0-4.714 0-5.69.976m12.837 1.956a.625.625 0 0 1-.08.88l-1.83 1.526c-.74.615-1.338 1.114-1.866 1.454-.55.354-1.087.578-1.704.578-.618 0-1.154-.224-1.704-.578-.529-.34-1.127-.839-1.866-1.454l-1.83-1.526a.625.625 0 0 1 .8-.96l1.8 1.5c.777.647 1.316 1.096 1.772 1.389.441.284.74.379 1.028.379.287 0 .587-.095 1.028-.38.455-.292.995-.74 1.773-1.389l1.799-1.499a.625.625 0 0 1 .88.08",
    clipRule: "evenodd"
  })));
};
export default SvgEnvelope;